import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Popover, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import config from 'src/config/config';
import { ReactComponent as CRM } from 'src/Images/icons/product/crm.svg';
import { ReactComponent as OMS } from 'src/Images/icons/product/oms.svg';
import { ReactComponent as VehicleTracking } from 'src/Images/icons/product/vehicleTracking.svg';
import { ReactComponent as InfoIcon } from 'src/Images/icons/common/target-info-icon.svg';

export default function ProductPopover({
  toggleProductPopover,
  openProductPopover,
}) {
  const authReducer = useSelector((state) => state.AuthReducer);
  const isMobile = useMediaQuery('(max-width:767px)');
  const themeColor = authReducer.userData.tenant?.theme;
  const domainName = authReducer.userData.tenant?.domain;
  const tenantSubscription = authReducer.userData.tenant?.subscriptions || [];

  const productData = [
    {
      id: 1,
      logo: <CRM className="product-icon-size" />,
      name: 'CRM',
      url: `https://${domainName}${config.domain_env_name}.crm.${config.domain_url}`,
    },
    {
      id: 2,
      logo: <OMS className="product-icon-size" />,
      name: 'OMS',
      url: `https://${domainName}${config.domain_env_name}.oms.${config.domain_url}`,
    },
    {
      id: 3,
      logo: <VehicleTracking className="product-icon-size" />,
      name: 'Vehicle Tracking',
      url: `https://${domainName}${config.domain_env_name}.vehicle-tracking.${config.domain_url}`,
    },
  ];

  const subscribedProductData = productData.map((product) => {
    const flag = tenantSubscription.find(
      (productName) =>
        productName.name?.toLowerCase() === product.name.toLowerCase(),
    );
    return {
      ...product,
      boolean: flag ? flag.boolean : false,
    };
  });

  return (
    <Popover
      open={Boolean(openProductPopover)}
      anchorEl={openProductPopover}
      onClose={toggleProductPopover}
      anchorOrigin={{
        vertical: isMobile ? 'top' : 'top',
        horizontal: isMobile ? 'center' : 'left',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: isMobile ? 'center' : 'left',
      }}
      PaperProps={{
        sx: {
          mt: isMobile ? '-30px' : '30px',
        },
      }}
    >
      <div className="navbar-domain-popover navbar-domain-popover-common-padding div-flex-column rg-5">
        <div className="py-2 div-flex-column navbar-domain-popover-common-padding">
          <span className="text-lg text-bold">The ERP Cloud</span>
          <div className="div-flex-row cg-5 div-align-center">
            <InfoIcon className="icon-size-sm" color="#9F9F9F" />
            <span className="text-sm text-grey">
              Seamless ERP integration. Smarter decisions. Stronger growth.
            </span>
          </div>
        </div>
        <Row
          className={`navbar-domain-popover-height theme-vertical-scrollable-container-${themeColor} m-0 rg-20`}
        >
          {subscribedProductData.map(
            (product) =>
              product?.boolean && (
                <Col
                  xs={6}
                  sm={6}
                  md={6}
                  lg={4}
                  xl={4}
                  xxl={4}
                  key={product.id}
                  className="pt-2"
                >
                  <a
                    href={product.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="icon-btn-none"
                  >
                    <button className="product-container div-flex-column rg-5">
                      <div className="div-flex-column div-align-center">
                        <div className="product-icon-size">{product.logo}</div>
                      </div>
                      <div className="product-container-divider" />
                      <span className="text-sm text-semi-bold">
                        {product.name}
                      </span>
                    </button>
                  </a>
                </Col>
              ),
          )}
        </Row>
      </div>
    </Popover>
  );
}
